export default __webpack_public_path__ + "static/media/copy.be83b2e5.svg";